<template>
  <div class="container" style="max-width: 420px">
    <div class="box">
      <h2 class="title is-5 has-text-centered mb-4">
        {{ $t("face login") }}
      </h2>
      <div
        class="has-text-centered mb-3"
        style="position: relative; display: inline-block"
      >
        <video
          ref="video"
          autoplay
          playsinline
          width="360"
          height="270"
          style="
            border-radius: 12px;
            border: 2px solid #00d1b2;
            background: #222;
            display: block;
          "
        ></video>
        <!-- Overlay SOLO sobre el video -->
        <div
          class="video-overlay"
          ref="overl"
          style="width: 100%; height: 100%"
        >
          <svg style="display: block; width: 100%; height: 100%">
            <defs>
              <mask id="mask-circle">
                <rect :width="videoWidth" :height="videoHeight" fill="white" />
                <circle
                  :cx="videoWidth / 2"
                  :cy="videoHeight / 2"
                  :r="100"
                  fill="black"
                />
              </mask>
            </defs>
            <rect
              :width="videoWidth"
              :height="videoHeight"
              fill="rgba(20,22,26,0.9)"
              :mask="'url(#mask-circle)'"
            />
            <circle
              :cx="videoWidth / 2"
              :cy="videoHeight / 2"
              :r="100"
              fill="none"
              stroke="#00d1b2"
              stroke-width="4"
            />
            <!-- <text
              :x="videoWidth / 2"
              :y="videoHeight / 2"
              text-anchor="middle"
              fill="#00d1b2"
              font-size="1"
              font-weight="bold"
              dy="7"
              style="user-select: none"
            >
              {{ $t("place your face here") }}
            </text> -->
          </svg>
        </div>
      </div>
      <div class="has-text-centered">
        <button
          class="button is-primary is-rounded"
          :class="{ 'is-loading': loading }"
          :disabled="loading"
          @click="startAuthentication"
        >
          <span class="icon"><i class="fa fa-smile-o"></i></span>
          <span>{{ $t("authenticate") }}</span>
        </button>
      </div>
      <p v-if="error" class="notification is-danger mt-3" v-html="error"></p>
    </div>
  </div>
</template>

<script>
// import { generate_error_message_text, post } from "@/utils"; // Asegúrate de que esta función esté definida en tu utils/api.js
export default {
  name: "FaceLogin",
  data() {
    return {
      stream: null,
      loading: false,
      error: "",
      intervalId: null,
      videoWidth: 360,
      videoHeight: 270,
    };
  },
  methods: {
    async startCamera() {
      try {
        this.stream = await navigator.mediaDevices.getUserMedia({
          video: { facingMode: "user" },
          audio: false,
        });
        this.$refs.video.srcObject = this.stream;
        this.$refs.video.onloadedmetadata = this.updateOverlaySize;
      } catch (e) {
        this.error = this.$t("Unable to access camera: ") + e.message;
      }
    },
    updateOverlaySize() {
      if (this.$refs.video) {
        // this.videoWidth = this.$refs.video.videoWidth || 360;
        // this.videoHeight = this.$refs.video.videoHeight || 270;
        this.videoWidth = this.$refs.overl.offsetWidth || 320;
        this.videoHeight = this.$refs.overl.offsetHeight || 240;
      }
    },
    startAuthentication() {
      this.error = "";
      // this.loading = true;
      // Enviar frames cada 1 segundo al servidor
      this.sendFrame();
    },
    async sendFrame() {
      let v = this;
      const video = this.$refs.video;
      if (!video || !video.srcObject) {
        this.error = this.$t("Camera not started");
        this.loading = false;
        clearInterval(this.intervalId);
        return;
      }
      const canvas = document.createElement("canvas");
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
      const dataURL = canvas.toDataURL("image/jpeg", 1);

      v.$emit("do_face_login", dataURL);

      // post("/system/authentication/face", { image: dataURL })
      //   .then((response) => {
      //     console.log("Face recognition response:", response);
      //   })
      //   .catch((error) => {
      //     this.error = generate_error_message_text(error);
      //   })
      //   .finally(() => {
      //     this.loading = false;
      //   });
    },
    start() {
      this.error = "";
      this.startCamera();
    },
  },
  mounted() {
    // this.startCamera();
  },
  beforeUnmount() {
    if (this.stream) {
      this.stream.getTracks().forEach((track) => track.stop());
    }
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  },
};
</script>

<style scoped>
.box {
  box-shadow: 0 2px 12px rgba(44, 62, 80, 0.08);
  border-radius: 16px;
}
.video-overlay {
  pointer-events: none;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
